<div class="container">
    <mat-card appearance="outlined">
        <mat-card-title class="btn btn-rose">Add New Projects</mat-card-title>
        <mat-card-subtitle></mat-card-subtitle>
        <mat-card-content>
            <form [formGroup]="addInvProjectForm" (ngSubmit)="addInvProjectForm.valid && saveInvProject()" novalidate>
                <div class="row">
                    <div class="col-md-6">
                      
                        <mat-form-field color="accent" appearance="fill" color="accent">
                            <mat-label>Project Name</mat-label>
                            <input matInput type="text" placeholder="ProjectName" name="projectName" id="projectName"
                                formControlName="projectName" maxlength="50" pattern=".*\S.*"  autocomplete="off">
                        </mat-form-field>
                    </div>
                    <div class="col-md-6">
                       
                        <mat-form-field color="accent" appearance="fill" color="accent">
                            <mat-label>Description</mat-label>
                            <input matInput type="text" placeholder="Description" name="description" id="description"
                                formControlName="description" maxlength="100" pattern=".*\S.*" autocomplete="off">
                        </mat-form-field>
                    </div>
                </div>
            </form>
        </mat-card-content>
        <mat-card-footer>
            <div class="row action-btn justify-content-center">
                <div class="col-md-6">
                    <button md-raised-button type="button" class="btn btn-round btn-block btn-rose"
                        (click)="close()">Close</button>
                </div>
                <div class="col-md-6">
                    <button md-raised-button type="button" class="btn btn-round btn-block btn-rose" (click)="saveInvProject()"
                        [disabled]="!addInvProjectForm.valid">Save</button>
                </div>
            </div>
        </mat-card-footer>
    </mat-card>
  </div>
  
    
  
